/**
 * Use this to redirect to external links
 */

export default ({path}) => {
  window.location.pathname = path;
  return null;
}
